/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var OneIcon = createIcon("OneIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#7719AA';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.44 30.18c3.574 0 5.796-2.493 5.796-6.66 0-4.212-2.25-6.714-5.796-6.714-3.554 0-5.85 2.511-5.85 6.714 0 4.185 2.25 6.66 5.85 6.66Zm0-1.836c-2.114 0-3.446-1.431-3.446-4.797 0-3.411 1.332-4.905 3.447-4.905 2.114 0 3.41 1.485 3.41 4.905 0 3.366-1.278 4.797-3.41 4.797ZM21.916 30v-9.549L28.46 30h1.971V16.986h-2.186v9.297l-6.372-9.297H19.73V30h2.186Zm20.394 0v-1.899l-6.543-.009v-3.726h5.661v-1.854h-5.642v-3.645h6.39l.008-1.881h-8.603V30h8.73Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.OneIcon",
  "replaceColor": true
});